import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

export const MatterTitleSkeleton = () => {
  return (
    <div className="w-full p-8 flex flex-wrap items-center gap-4 justify-between">
      <div className="flex flex-col">
        <div className="flex items-center">
          <Skeleton className="h-8 w-64 mb-1" />
          {/* WorkflowIndicator placeholder */}
          <Skeleton className="h-5 w-5 ml-2 rounded-full" />
        </div>
        <Skeleton className="h-5 w-40" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-wrap items-center gap-2 sm:justify-end">
          <Skeleton className="h-6 w-20 bg-zinc-50 rounded px-1.5 py-0.5" />
          <Skeleton className="h-6 w-24 bg-zinc-50 rounded px-1.5 py-0.5" />
        </div>

        <div className="flex flex-wrap gap-2 sm:justify-end">
          <Skeleton className="h-6 w-24 bg-zinc-50 rounded px-1.5 py-0.5" />
          <Skeleton className="h-6 w-24 bg-zinc-50 rounded px-1.5 py-0.5" />
          <Skeleton className="h-6 w-32 bg-zinc-50 rounded px-1.5 py-0.5" />
        </div>
      </div>
    </div>
  );
};

export const TableOfContentsSkeleton = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div className={cn('p-3 h-full flex flex-col', className)}>
      {/* Header */}
      <div className="mb-3">
        <Skeleton className="h-5 w-32 mb-2" />
        <Skeleton className="h-5 w-28 mb-2" />
      </div>

      {/* Body */}
      <div className="flex-1 space-y-2">
        <Skeleton className="h-5 w-4/5" />

        <div className="ml-2 space-y-1.5 mt-1">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-4 w-3/5" />
        </div>

        <Skeleton className="h-5 w-3/4 mt-4" />

        <div className="ml-2 space-y-1.5 mt-1">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-3/5" />
        </div>

        <Skeleton className="h-5 w-3/5 mt-4" />

        <div className="ml-2 space-y-1.5 mt-1">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>
    </div>
  );
};

export const MatterNavSkeleton = () => {
  return (
    <div>
      <div className="px-4 pt-4 pb-3">
        <MatterTitleSkeleton />
      </div>
      <div className="flex justify-between items-center border-t border-zinc-100">
        <div className="flex overflow-x-auto no-scrollbar">
          <Skeleton className="h-10 w-20 mx-2" />
          <Skeleton className="h-10 w-28 mx-2" />
          <Skeleton className="h-10 w-24 mx-2" />
          <Skeleton className="h-10 w-24 mx-2" />
        </div>
        <div className="h-full border-l-2 border-zinc-100 flex px-4">
          <Skeleton className="h-8 w-8" />
        </div>
      </div>
    </div>
  );
};

export const MatterContentSkeleton = () => {
  return (
    <div className="p-4 space-y-6">
      <Skeleton className="h-8 w-1/3" />
      <div className="space-y-4">
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-40 w-full" />
      </div>
    </div>
  );
};

export const TaskPanelSkeleton = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="sticky top-0 bg-white py-2 px-2">
        <div className="flex flex-row items-center justify-between">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
      <div className="overflow-y-auto flex-grow px-2">
        <div className="px-2">
          <div className="space-y-4 mt-4">
            <Skeleton className="h-6 w-32" />
            <div className="space-y-2">
              <Skeleton className="h-16 w-full rounded-md" />
              <Skeleton className="h-16 w-full rounded-md" />
            </div>

            <Skeleton className="h-6 w-40 mt-6" />
            <div className="space-y-2">
              <Skeleton className="h-16 w-full rounded-md" />
              <Skeleton className="h-16 w-full rounded-md" />
              <Skeleton className="h-16 w-full rounded-md" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
